import { defineNuxtPlugin } from '@nuxtjs/composition-api';
import * as dynamicModals from '~/constants/dynamicModals';

const globalConstants = {
  dynamicModals,
};

export default defineNuxtPlugin((_, inject) => {
  inject('constants', globalConstants);
});
